import shareComponents from "../../web-sh/src/components/share";
import NoItem from "./NoItem";

shareComponents.NoItem = NoItem;

export default shareComponents;